import type { IconProps } from './types';

export function Body({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 68 Q88 64 100 68 Q128 88 156 68 Q168 64 180 68 Q204 80 224 104 Q216 112 208 116 Q198 108 188 96 L188 156 Q176 184 152 200 Q140 208 128 208 Q116 208 104 200 Q80 184 68 156 L68 96 Q58 108 48 116 Q40 112 32 104 Q52 80 76 68 Z" />
      <circle cx="112" cy="208" r="4" />
      <circle cx="128" cy="208" r="4" />
      <circle cx="144" cy="208" r="4" />
    </svg>
  );
}
